import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DropdownPropTypes } from './Dropdown';
import MenuItem, { MenuItemPropTypes, MenuItemDefaultProps } from './MenuItem';

import './Menu.scss';

export const MenuPropTypes = {
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.any),
  getKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  ...MenuItemPropTypes,
};

const Menu = ({ id, items, getKey, isOpen, title, className, Item = MenuItem, ...restProps }) => {
  if (!isOpen) return null;

  return (
    <div id={id} className={classNames('dropdown-menu', className)}>
      {title && <Item item={title} isTitle />}
      {items.map(item => {
        const key = typeof getKey === 'string' ? item[getKey] : getKey(item);
        return <Item {...restProps} key={key} item={item} />;
      })}
    </div>
  );
};

Menu.defaultProps = {
  items: [],
  ...MenuItemDefaultProps,
};

Menu.propTypes = {
  ...MenuPropTypes,
  ...DropdownPropTypes,
};

export default Menu;
